import { render } from "./ThreeDotsMenu.vue?vue&type=template&id=4ba6a6c6&scoped=true"
import script from "./ThreeDotsMenu.vue?vue&type=script&lang=js"
export * from "./ThreeDotsMenu.vue?vue&type=script&lang=js"

import "./ThreeDotsMenu.vue?vue&type=style&index=0&id=4ba6a6c6&scoped=true&lang=css"
import "./ThreeDotsMenu.vue?vue&type=style&index=1&id=4ba6a6c6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba6a6c6"]])

export default __exports__